export default __webpack_public_path__ + "static/media/3.6063d355.jpeg";